// ABOUTME: Pure date-range helper for BehaviorBreakdownChart, split out from the
// ABOUTME: component so it can be unit-tested without importing recharts (issue #1775 hang, #1881)

import { getTodayInFamilyTimezone } from '../utils/dateUtils';
import type { BehaviorBreakdownChartProps } from './BehaviorBreakdownChart';

export function getDateRange(
  tab: BehaviorBreakdownChartProps['tab'],
  familyTimezone: string | undefined,
  familyCreatedAt: string | undefined
): { startDate: string; endDate: string } {
  const today = getTodayInFamilyTimezone(familyTimezone);

  if (tab === 'All Time') {
    const startDate = familyCreatedAt
      ? familyCreatedAt.split('T')[0]
      : today;
    return { startDate, endDate: today };
  }

  const daysBack: Record<string, number> = {
    'Week': 6,
    'Month': 29,
    '3 Months': 89,
    '6 Months': 179,
  };

  const days = daysBack[tab] ?? 29;
  // Pure calendar-day arithmetic via Date.UTC + getUTC* — never touches the
  // browser's local timezone, so it can't shift the day the way the local Date
  // constructor can. `today` is already correct for the family timezone, so no
  // further conversion through familyTimezone is needed (or safe) here.
  const todayParts = today.split('-').map(Number);
  const anchor = new Date(Date.UTC(todayParts[0], todayParts[1] - 1, todayParts[2] - days));
  const startDate = `${anchor.getUTCFullYear()}-${String(anchor.getUTCMonth() + 1).padStart(2, '0')}-${String(anchor.getUTCDate()).padStart(2, '0')}`;
  return {
    startDate,
    endDate: today,
  };
}
